export const VIEW360_METHODS = [
  "destroy",
  "init",
  "load",
  "resize",
  "addPlugins",
  "removePlugins",
  "renderFrame",
  // @egjs/component methods
  "on",
  "hasOn",
  "once",
  "off",
  "trigger"
] as const;
